export default "__VITE_ASSET__EOzXt05c__"